import React from "react";
import {RestaurantDeliveryArea} from "@/data/entities/restaurant";
import {Badge} from "peggirkit";
import BadgeIconIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeIconIndicator";
import {InformationCircleIcon} from "@heroicons/react/16/solid";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {formatMoney} from "@/utils/MoneyUtils";
import {FormattedMessage, useIntl} from "react-intl";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";

const DeliveryAreas = () => {
    const {dashboardLocation} = useRestaurant();
    const intl = useIntl();
    const {applyTooltip} = useTooltip();

    return (
        <div
            className={"w-full flex flex-col items-start justify-start gap-1.5 pb-5 mb-5 border-b border-gray-300 dark:border-slate-700"}
        >
            <p className={"text-sm text-gray-600 dark:text-slate-400"}>
                <FormattedMessage
                    id={"deliveryAreasOfLocation"}
                    values={{location: dashboardLocation.name}}
                />
            </p>
            <ul className={"w-full flex flex-row flex-wrap items-start justify-start gap-1.5 "}>
                {dashboardLocation.deliveryAreas.map((area: RestaurantDeliveryArea) =>
                    <li key={area.postalCode}>
                        <Badge
                            containerClassname={"cursor-help"}
                            color={"secondary"}
                            variant={"flat"}
                            radius={"chip"}
                            indicator={BadgeIconIndicator({icon: InformationCircleIcon})}
                            props={{
                                ...applyTooltip(
                                    intl.formatMessage(
                                        {id: "deliveryAreaInfoTip"},
                                        {
                                            deliveryFee: formatMoney(area.deliveryFee),
                                            minimumOrderAmount: formatMoney(area.minimumOrderAmount),
                                        },
                                    )
                                ),
                            }}
                        >
                            {area.postalCode}
                        </Badge>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default DeliveryAreas;